export default __webpack_public_path__ + "static/expertise-737974ae956f87ea5edd1579b3a12fc8.webp";